module.exports = __webpack_public_path__ + "img/comming_soonimg.ba3874d9.png";